var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("table", { staticClass: "create_table" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("tbody", [
        _c("tr", [
          _vm._m(2),
          _vm._v(" "),
          _c("td", [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.distinctionType,
                    expression: "distinctionType"
                  }
                ],
                staticClass: "slt_white w100",
                attrs: { disabled: _vm.viewMode },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.distinctionType = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "SB", selected: "" } }, [
                  _vm._v("Service Bulletin")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "MX" } }, [
                  _vm._v("Service Bulletin(Mobile)")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm.distinctionType == "SB"
            ? _c("td", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.categoryStatus,
                        expression: "categoryStatus"
                      }
                    ],
                    staticClass: "slt_white w100",
                    attrs: { id: "categoryStatus" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.categoryStatus = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function($event) {
                          return _vm.changeCategory1($event)
                        }
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "", selected: "" } }, [
                      _vm._v("ALL")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.categoryComboList, function(item) {
                      return _vm.categoryComboList.length > 0
                        ? _c(
                            "option",
                            { key: item.code, domProps: { value: item.code } },
                            [_vm._v(_vm._s(item.codeName))]
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.distinctionType == "MX"
            ? _c("td", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.categoryStatusMX,
                        expression: "categoryStatusMX"
                      }
                    ],
                    staticClass: "slt_white w100",
                    attrs: { disabled: true },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.categoryStatusMX = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "D", selected: "" } }, [
                      _vm._v("Mobile Phone")
                    ])
                  ]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("tr", [
          _vm.distinctionType == "SB"
            ? _c("th", [
                _vm._v("Guide Type"),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.distinctionType == "SB"
            ? _c("td", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.guideType,
                        expression: "guideType"
                      }
                    ],
                    staticClass: "slt_white w100",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.guideType = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "", selected: "" } }, [
                      _vm._v("Select Guide Type")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "ALL" } }, [
                      _vm._v("ALL (including five types below)")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "P" } }, [
                      _vm._v("Parts Used")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "S" } }, [
                      _vm._v("S/W & Firmware")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "A" } }, [
                      _vm._v("Alternative Parts")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "O" } }, [
                      _vm._v("On Site Check Guide")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "R" } }, [
                      _vm._v("Repair Information & Tips")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "M" } }, [
                      _vm._v("Manufacturing BOM Change")
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _c("td", [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.roleStatus,
                    expression: "roleStatus"
                  }
                ],
                staticClass: "slt_white w100",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.roleStatus = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "", selected: "" } }, [
                  _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "1" } }, [_vm._v("Approval")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "2" } }, [_vm._v("Consent")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "3" } }, [
                  _vm._v("Post Approval")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "4" } }, [
                  _vm._v("Parallel Consent")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "7" } }, [
                  _vm._v("Parallel Approval")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "9" } }, [
                  _vm._v("Notification")
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _vm._m(5),
          _vm._v(" "),
          _c("td", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.SORTORD,
                  expression: "SORTORD"
                }
              ],
              ref: "SORTORD",
              staticClass: "text_input w100",
              attrs: {
                type: "text",
                disabled: false,
                placeholder: "Please set the approval order.",
                maxlength: "10"
              },
              domProps: { value: _vm.SORTORD },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.SORTORD = $event.target.value
                  },
                  _vm.handleNumberInput
                ]
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _vm._m(6),
          _vm._v(" "),
          _c("td", [
            _c("fieldset", { staticClass: "ui_fieldset" }, [
              _c("label", { staticClass: "serach-wrap w100p" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.emailAddresses,
                      expression: "emailAddresses"
                    }
                  ],
                  staticClass: "text_input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.emailAddresses },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.stopPropagation()
                      return _vm.emailAddressFind(_vm.emailAddresses)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.emailAddresses = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "in_btn_search",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.emailAddressFind(_vm.emailAddresses)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "ico_input_serach" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr_only" })
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("th", [_vm._v("Name ")]),
          _vm._v(" "),
          _c("td", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.knoxName,
                  expression: "knoxName"
                }
              ],
              ref: "knoxName",
              staticClass: "text_input w100",
              attrs: { type: "text", disabled: true },
              domProps: { value: _vm.knoxName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.knoxName = $event.target.value
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("Email ")]),
          _vm._v(" "),
          _c("td", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.Email,
                  expression: "Email"
                }
              ],
              ref: "Email",
              staticClass: "text_input w100",
              attrs: { type: "text", disabled: true },
              domProps: { value: _vm.Email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.Email = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("th", [_vm._v("KnoxId ")]),
          _vm._v(" "),
          _c("td", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.knoxId,
                  expression: "knoxId"
                }
              ],
              ref: "knoxId",
              staticClass: "text_input w100",
              attrs: { type: "text", disabled: true },
              domProps: { value: _vm.knoxId },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.knoxId = $event.target.value
                }
              }
            })
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn_wrap topLine" }, [
      _c(
        "a",
        {
          staticClass: "btn_white size_full",
          attrs: { href: "JavaScript:", title: "" },
          on: {
            click: function($event) {
              return _vm.goList()
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.LIST")))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "btn_right" }, [
        _c(
          "a",
          {
            staticClass: "btn_white",
            attrs: { href: "JavaScript:" },
            on: {
              click: function($event) {
                return _vm.cateDelete()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")))]
        ),
        _vm._v(" "),
        !_vm.viewMode
          ? _c(
              "a",
              {
                staticClass: "btn_blue",
                on: {
                  click: function($event) {
                    return _vm.cateSave("S")
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SAVE")))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.viewMode
          ? _c(
              "a",
              {
                staticClass: "btn_blue",
                on: {
                  click: function($event) {
                    return _vm.cateSave("U")
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.UPDATE")))]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid_wrap mt25" }, [
      _c("div", { staticClass: "sub_tit" }, [_vm._v("Basic Information")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "14.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("Contents Type"),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("Product Category"),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("Role"),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("Sort"),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("User Name/Email "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1038eb99", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1038eb99","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/knowledgeManager/approval/ApprovalManageView.vue
// module id = nZki
// module chunks = 0